import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { push } from 'react-router-redux'
import { deleteSinglePrice, modifySinglePrice } from '../actions/calendars'
import LoadingProgress from './LoadingProgress'

class Calendar extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      selectedPriceEntry: null,      // The price entry currently open for inline edit
      editingPriceId: null,          // Id of the price being edited inline
      newPrice: '',                  // Current inline input value
      confirmingDeleteId: null,      // Id of the price pending delete confirmation
      selectedDayEntry: null,
      selectedMonthEntry: null,
      selectedYearEntry: null,
    };
  }

  generateCalendarDays(month, year) {
    const days = [];
    const firstDate = new Date(year, month, 1);
    const lastDate = new Date(year, month + 1, 0);

    let firstDayIndex = firstDate.getDay();

    // Adjust firstDayIndex so that 0 represents Monday
    firstDayIndex = (firstDayIndex === 0) ? 6 : firstDayIndex - 1;

    // Add empty slots for the days before the first day of the month
    for (let i = 0; i < firstDayIndex; i++) {
      days.push({ day: null });
    }

    // Add the actual days of the month
    for (let i = 1; i <= lastDate.getDate(); i++) {
      const dayDate = new Date(year, month, i);

      // Correct way to compare dates (ignoring time)
      const priceData = this.props.priceCalendar.find(
        (entry) => {
          const entryDate = new Date(entry.date);
          return (
            entryDate.getDate() === dayDate.getDate() &&
            entryDate.getMonth() === dayDate.getMonth() &&
            entryDate.getFullYear() === dayDate.getFullYear()
          );
        }
      );

      days.push({ day: i, priceData });
    }

    return days;
  }

  getZoneNameOld(zone) {

    switch (zone) {
      case 0:
        return 'GENERAL';
      case 1:
        return 'BAQUEIRA';
      case 2:
        return 'BERET';
      case 3:
        return 'BONAIGUA';
      case 4:
        return 'RUDA';
      case 5:
        return 'BOSQUE';
      default:
        return 'NONE';
    }
  }

  getZoneName(zone) {
    const { customer } = this.props;
    if (!customer || !customer.Zones) return 'NONE';

    const foundZone = customer.Zones.find(z => z.Zone === zone);
    return foundZone ? foundZone.Description : 'NONE';
  }

  getZoneColor(zone) {

    switch (zone) {
      case 0:
        return 'bg-primary';
      case 1:
        return 'bg-white';
      case 2:
        return 'bg-success';
      case 3:
        return 'bg-info';
      case 4:
        return 'bg-warning';
      case 5:
        return 'bg-secondary';
      default:
        return 'bg-danger';
    }
  }

  getTypeName(type) {
    const { category } = this.props;

    if (category === 'BAQUEIRA') {
      switch (type) {
        case 'BN3XL':
          return '2 PAX';
        case 'CN3XL':
          return '3 PAX';
        case 'BW3XL':
          return '4 PAX';
        default:
          return 'NONE';
      }
    } else {
      switch (type) {
        case 'BNS':
          return 'Standard';
        case 'CNS':
          return 'Standard Carga';
        case 'BWS':
          return 'Standard XL';
        case 'CWS':
          return 'Standard Carga XL';
        case 'BNM':
          return 'Medium';
        case 'CNM':
          return 'Medium Carga';
        case 'BWM':
          return 'Medium XL';
        case 'CWM':
          return 'Medium Carga XL';
        case 'BNL':
          return 'Large';
        case 'CNL':
          return 'Large Carga';
        case 'BWL':
          return 'Large XL';
        case 'CWL':
          return 'Large Carga XL';
        case 'BNXL':
          return 'Large 4';
        case 'CNXL':
          return 'Large 4 Carga';
        case 'BWXL':
          return 'Large 4 XL';
        case 'CWXL':
          return 'Large 4 Carga XL';
        case 'BN2XL':
          return 'Large 5';
        case 'CN2XL':
          return 'Large 5 Carga';
        case 'BW2XL':
          return 'Large 5 XL';
        case 'CW2XL':
          return 'Large 5 Carga XL';
        case 'BN3XL':
          return 'Ski';
        case 'CN3XL':
          return 'Ski Carga';
        case 'BW3XL':
          return 'Ski XL';
        case 'CW3XL':
          return 'Ski Carga XL';
        // Voucher/Coupon Types (X and W, no LOCKER prefix)
        case 'XNS':
          return 'Standard Cupón';
        case 'XWS':
          return 'Standard XL Cupón';
        case 'XNM':
          return 'Medium Cupón';
        case 'XWM':
          return 'Medium XL Cupón';
        case 'XNL':
          return 'Large Cupón';
        case 'XWL':
          return 'Large XL Cupón';
        case 'XNXL':
          return 'Large 4 Cupón';
        case 'XWXL':
          return 'Large 4 XL Cupón';
        case 'XN2XL':
          return 'Large 5 Cupón';
        case 'XW2XL':
          return 'Large 5 XL Cupón';
        case 'XN3XL':
          return 'Ski Cupón';
        case 'XW3XL':
          return 'Ski XL Cupón';
        default:
          return 'NONE';
      }
    }
  }

  // Begin inline modification of a price (renders an input inside the cell)
  handleStartModify = (e, price) => {
    if (e) e.stopPropagation();
    this.setState({
      editingPriceId: price._id,
      newPrice: price.price,
      confirmingDeleteId: null,
    });
  };

  // Confirm inline deletion
  handleConfirmDelete = (e, price) => {
    if (e) e.stopPropagation();
    this.props.deleteSinglePrice(price._id);
    this.setState({
      confirmingDeleteId: null,
      selectedPriceEntry: null,
      editingPriceId: null,
      newPrice: '',
    });
  };

  // Ask for delete confirmation inline
  handleAskDelete = (e, price) => {
    if (e) e.stopPropagation();
    this.setState({
      confirmingDeleteId: price._id,
      editingPriceId: null,
    });
  };

  // Submit inline modification
  handleConfirmModify = (e, price) => {
    if (e) e.preventDefault();
    if (e) e.stopPropagation();
    const { newPrice } = this.state;
    if (newPrice === '' || isNaN(parseFloat(newPrice))) return;
    this.props.modifySinglePrice(price._id, parseFloat(newPrice));
    this.setState({
      editingPriceId: null,
      selectedPriceEntry: null,
      newPrice: '',
    });
  };

  // Cancel inline edit / delete-confirm
  handleCancelInline = (e) => {
    if (e) e.stopPropagation();
    this.setState({
      editingPriceId: null,
      confirmingDeleteId: null,
      newPrice: '',
    });
  };

  handlePriceChange = (event) => {
    this.setState({ newPrice: event.target.value });
  };

  handlePriceEntryClick = (price, day, month, year) => {
    const wasSelected = this.state.selectedPriceEntry === price;
    this.setState({
      selectedPriceEntry: wasSelected ? null : price,
      selectedDayEntry: day,
      selectedMonthEntry: month,
      selectedYearEntry: year,
      // closing the entry also closes any inline editor on it
      editingPriceId: wasSelected ? null : this.state.editingPriceId,
      confirmingDeleteId: wasSelected ? null : this.state.confirmingDeleteId,
    });
  };

  render() {
    const { startYear, endYear, startMonth, endMonth, customer } = this.props;
    const { selectedPriceEntry, editingPriceId, confirmingDeleteId, newPrice } = this.state;

    const monthNames = [
      'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
      'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
    ];

    // Determine the range of months to display
    const monthsToDisplay = [];
    
    // If years are the same, only show months in that year
    if (startYear === endYear) {
      for (let i = startMonth; i <= endMonth; i++) {
        monthsToDisplay.push({ month: i, year: startYear });
      }
    } else {
      // Show months from startMonth to December in startYear
      for (let i = startMonth; i <= 11; i++) {
        monthsToDisplay.push({ month: i, year: startYear });
      }
      
      // Show months for any full years in between
      for (let year = startYear + 1; year < endYear; year++) {
        for (let i = 0; i <= 11; i++) {
          monthsToDisplay.push({ month: i, year });
        }
      }
      
      // Show months from January to endMonth in endYear
      for (let i = 0; i <= endMonth; i++) {
        monthsToDisplay.push({ month: i, year: endYear });
      }
    }

    if (!customer) {
      return <LoadingProgress />
    }

    return (
      <div className="mt-5">
        {monthsToDisplay.map(({ month, year }) => {
          const days = this.generateCalendarDays(month, year);
          const hasPrices = days.some(day => day.priceData);

          if (!hasPrices) return null;

          return (
            <div key={`${month}-${year}`} className="calendar">
              <h5>{monthNames[month]} {year}</h5>
              <div className="calendar-grid">
                {['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'].map((day) => (
                  <div key={day} className="calendar-day-header">{day}</div>
                ))}
                {days.map((day, index) => (
                  <div
                    key={index}
                    className={`calendar-operator-day ${day.day ? (day.priceData ? 'with-price' : 'no-price') : 'no-day'}`}>
                    {day.day && (
                      <>
                        <span className="day-number">{day.day}</span>
                        {day.priceData && (
                          <div className="price-info">
                            {day.priceData.prices
                              .slice() // Create a shallow copy of the array to avoid mutating the original array
                              .sort((a, b) => {
                                const nameA = this.getZoneName(a.zone).toUpperCase(); // Convert to uppercase to ensure case-insensitive comparison
                                const nameB = this.getZoneName(b.zone).toUpperCase(); // Convert to uppercase to ensure case-insensitive comparison
                                if (nameA < nameB) return -1;
                                if (nameA > nameB) return 1;
                                return 0;
                              })
                              .map((price, idx) => {
                                const isEditing = editingPriceId === price._id;
                                const isConfirmingDelete = confirmingDeleteId === price._id;
                                const isSelected = selectedPriceEntry === price;
                                return (
                                  <div
                                    key={idx}
                                    className={`price-entry ${this.getZoneColor(price.zone)}`}
                                    onClick={() => !isEditing && !isConfirmingDelete && this.handlePriceEntryClick(price, day.day, month, year)}
                                  >
                                    {!isEditing && !isConfirmingDelete && (
                                      <span>{this.getZoneName(price.zone)} - {this.getTypeName(price.type)}: {(price.price).toFixed(2)}€</span>
                                    )}

                                    {isEditing && (
                                      <form
                                        onSubmit={(e) => this.handleConfirmModify(e, price)}
                                        onClick={(e) => e.stopPropagation()}
                                        className="price-inline-edit"
                                      >
                                        <div className="small mb-1">
                                          {this.getZoneName(price.zone)} - {this.getTypeName(price.type)}
                                        </div>
                                        <input
                                          type="number"
                                          step="0.01"
                                          autoFocus
                                          required
                                          value={newPrice}
                                          onChange={this.handlePriceChange}
                                          onClick={(e) => e.stopPropagation()}
                                          className="form-control form-control-sm text-center"
                                        />
                                        <div className="price-buttons mt-1 d-flex justify-content-center">
                                          <button type="submit" className="btn btn-sm bg-info text-white mr-1" title="Guardar">
                                            <i className="fas fa-check"></i>
                                          </button>
                                          <button type="button" className="btn btn-sm bg-secondary text-white" title="Cancelar" onClick={this.handleCancelInline}>
                                            <i className="fas fa-times"></i>
                                          </button>
                                        </div>
                                      </form>
                                    )}

                                    {isConfirmingDelete && (
                                      <div className="price-inline-edit" onClick={(e) => e.stopPropagation()}>
                                        <div className="small mb-1">¿Eliminar?</div>
                                        <div className="price-buttons d-flex justify-content-center">
                                          <button type="button" className="btn btn-sm bg-danger text-white mr-1" title="Sí, eliminar" onClick={(e) => this.handleConfirmDelete(e, price)}>
                                            <i className="fas fa-check"></i>
                                          </button>
                                          <button type="button" className="btn btn-sm bg-secondary text-white" title="Cancelar" onClick={this.handleCancelInline}>
                                            <i className="fas fa-times"></i>
                                          </button>
                                        </div>
                                      </div>
                                    )}

                                    {isSelected && !isEditing && !isConfirmingDelete && (
                                      <div className="price-buttons mt-1 d-flex justify-content-center">
                                        <button className="btn btn-sm bg-vw-dark text-white mr-1" onClick={(e) => this.handleStartModify(e, price)}>
                                          <i className="fas fa-pen mr-1"></i>Modificar
                                        </button>
                                        <button className="btn btn-sm bg-danger text-white" onClick={(e) => this.handleAskDelete(e, price)}>
                                          <i className="fas fa-trash mr-1"></i>Eliminar
                                        </button>
                                      </div>
                                    )}
                                  </div>
                                );
                              })}
                          </div>
                        )}
                      </>
                    )}
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  priceCalendar: state.calendars.calendar.PriceCalendar,
  calendar: state.calendars.calendar,
  category: state.auth.category,
  loading: state.calendars.loading,
  error: state.calendars.error,
});

const mapDispatchToProps = dispatch => ({
  deleteSinglePrice: bindActionCreators(deleteSinglePrice, dispatch),
  modifySinglePrice: bindActionCreators(modifySinglePrice, dispatch),
  push: bindActionCreators(push, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Calendar);